import { useState, useEffect } from 'react';
import { api } from '@/lib/api';
import type { CashierUser } from '@photobooth/api-client';

export function useCashiers(outletId?: string) {
  const [cashiers, setCashiers] = useState<CashierUser[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCashiers = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await api.cashiers.getAll(outletId);
      if (response.success && response.data) {
        // Handle nested data structure from API client
        const cashiersData = (response.data as any).data || response.data;
        setCashiers(Array.isArray(cashiersData) ? cashiersData : []);
      } else {
        setError('Failed to fetch cashiers');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch cashiers');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCashiers();
  }, [outletId]);

  return {
    cashiers,
    isLoading,
    error,
    refetch: fetchCashiers,
  };
}
